import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import MarineFisherySubsectorService from "@services/MarineFisherySubsectorService";

const ShowMarineFisherySubsector = ({ marineFisherySubsector }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [marineFisherySubsectorData, setMarineFisherySubsectorData] = useState(
    []
  );

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      MarineFisherySubsectorService.find(marineFisherySubsector.id).then(
        (response) => {
          setMarineFisherySubsectorData(response.data.data);
        }
      );
  }, [marineFisherySubsector.id, showModal]);

  return (
    <PermissionHandler permission={"view_marine_fishery_sub_sectors"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails
            label={t("name")}
            value={marineFisherySubsectorData.name}
          />
          <RowDetails
            label={t("nameEng")}
            value={marineFisherySubsectorData.name_eng}
          />
          <RowDetails
            label={t("name")}
            value={marineFisherySubsectorData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowMarineFisherySubsector;
